/*
  Looping silent clips on the UNA page: the "Easy to start" steps (.una-easy) and the CONNECT loop
  (.una-connect). Each clip loads the first time it comes into view, plays while it is on screen and
  pauses when it leaves. No fades: the clips just loop. Clicking the clip, or Enter or Space on it,
  pauses or plays it; a clip the viewer paused stays paused when scrolled back into view.
  Skipped for reduced motion and data saver, where the poster stills stay.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var connection = navigator.connection;
  if (connection && connection.saveData) return;

  function setup(video) {
    if (video.dataset.unaEasy) return;
    video.dataset.unaEasy = 'ready';

    var box = video.parentElement;
    var badge = box.querySelector('.una-easy__badge, .una-connect__badge');
    var userPaused = false;

    box.setAttribute('role', 'button');
    box.setAttribute('tabindex', '0');
    if (box.dataset.label) box.setAttribute('aria-label', 'Pause or play clip: ' + box.dataset.label);

    function play() {
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }

    function toggle() {
      userPaused = !userPaused;
      if (badge) badge.hidden = !userPaused;
      if (userPaused) video.pause();
      else play();
    }

    box.addEventListener('click', toggle);
    box.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) video.pause();
          else if (!userPaused) play();
        });
      },
      { threshold: 0.4 }
    ).observe(video);
  }

  function init(root) {
    root.querySelectorAll('.una-easy video[data-src], .una-connect video[data-src]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
